/**
 * Esta constante no debe ser cambiada a menos de que la url
 * de la API haya cambiado. Si esta buscando cambiar la rula
 * de la api en desarrollo, ve al archivo vue.config.js linea 25
 */
// let url = "";

// if (process.env.NODE_ENV !== "development") {
//   url = "https://apicloud.magycorp.com:48028";
//
// } else {
//   url = "https://apis.magycorp.com:48028";
//
// }
//export const BASE_API_URL = "http://localhost:44308/";
// export const BASE_API_URL = "http://localhost:44308/";

// QA
//export const BASE_API_URL = "https://apis.magycorp.com:48028";
// PRO
export const BASE_API_URL = "https://apicloud.magycorp.com:48028";
// LOCAL
export const BASE_API_URL_Local = "http://localhost:44308";

export const AUTH_URL = "/api/Auth/login";
export const USER_INFO = "/api/Auth/info";

export const BASE_NAVIXY_API_URL = "https://api.navixy.com/v2/";
export const BASE_NAVIXY_API_PANEL_URL = "https://api.navixy.com/v2/panel/";

// export const NAVIXY_PANEL_PASSWORD = "MagyTrack2020@1";
export const NAVIXY_PANEL_USERNAME = "27496";
export const NAVIXY_PANEL_PASSWORD = "@Tennos@2022";

/**
 * Codigos de las empresas, utilizado para no
 * harcodear esos codigos.
 */
export const COMPANYS = {
  MTR: "MTR",
  TB: "TB",
  RB: "RB",
  MGPSLA: "MGPSLA",
  MGPTSA: "MGPTSA",
  MGPTT: "MGPTT"
};

/** Parametros por defecto del paginador */
export const PAGINATION_DEFAULT = {
  // pageSizes: [10,20,30,50,100,500],
  pageSize: 10,
  currentPage: 1,
  total: 0,
  skip: 0
};

/** Lista de nombres de los meses en ingles. */
export const MONTHS_LIST = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const MONTHS_LIST_WITH_WIDTH = [
  { label: "January", width: 100, index: 1 },
  { label: "February", width: 100, index: 2 },
  { label: "March", width: 100, index: 3 },
  { label: "April", width: 100, index: 4 },
  { label: "May", width: 100, index: 5 },
  { label: "June", width: 100, index: 6 },
  { label: "July", width: 100, index: 7 },
  { label: "August", width: 100, index: 8 },
  { label: "September", width: 125, index: 9 },
  { label: "October", width: 100, index: 10 },
  { label: "November", width: 125, index: 11 },
  { label: "December", width: 125, index: 12 }
];

export const NAME_REQUEST_DEMO = "Demo";

export const USER_ID_NAVIXY_DEMO = 225325;

export const LIST_COMPANYS = [
  {
    label: "Consolidado",
    value: "ALL"
  },
  {
    label: "Rabbey",
    value: "RB"
  },
  {
    label: "Tennos Business",
    value: "TB"
  },
  {
    label: "Magytrack",
    value: "MTR"
  },
  {
    label: "Magycorp SA",
    value: "SA"
  },
  {
    label: "Magycorp Technology",
    value: "MTECH"
  }
];
